
import {  TiposDeDados } from "@/core/config/PerfisConfig";


class Feriado {  


    public static campos = () => {
        return [   
            
            {
                nome: "tipo",
                type: "select",
                label: "Tipo",
                sm: 6 ,
                lg: 4, 
                disabled: false,
                options:  TiposDeDados.tipoferiado() 
            },  
            {
                nome: "Data",
                type: "date",
                label: "Data",
                sm: 6 ,
                lg: 4, 
                disabled: false
            },   
        ];
    }   
}
  
export   {   Feriado };
